import { Card, CardContent, Grid, Typography } from "@mui/material";
import useAuth from "@/hooks/useAuth";
import AlgoTradingSummaryCard from "@/pages/AlgoTradingSummaryCard";

export function DashboardPage() {
  const { user } = useAuth();

  return (
    <div>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Welcome back, {user?.full_name}
      </Typography>
      <Typography variant="body1" color="text.secondary" mb={4}>
        Here's a quick overview of your TekInvest account.
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardContent>
              <Typography variant="overline" color="text.secondary">
                Account Status
              </Typography>
              <Typography variant="h5" fontWeight={600}>
                {user?.is_active ? "Active" : "Inactive"}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardContent>
              <Typography variant="overline" color="text.secondary">
                Roles
              </Typography>
              <Typography variant="h5" fontWeight={600}>
                {user?.roles.map((r) => r.name).join(", ") || "—"}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Card>
            <CardContent>
              <Typography variant="overline" color="text.secondary">
                Last Login
              </Typography>
              <Typography variant="h5" fontWeight={600}>
                {user?.last_login_at ? new Date(user.last_login_at).toLocaleString() : "First login"}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Grid container sx={{ mt: 3 }}>
        <Grid item xs={12}>
          <AlgoTradingSummaryCard />
        </Grid>
      </Grid>
    </div>
  );
}

export default DashboardPage;
